/**
 * @description 基于背包模块(packages/prize-backpack/components/PrizeBackpackDialog.vue)，统一封装unit 与 noBoostUnit，保证模块展示一致性
 * @param {Object} prize 奖励对象
 * @param {Number} prize.unit 奖励对应数量
 * @param {Number} prize.noBoostUnit 奖励未膨胀数量
 */

export function formatePrizeUnit(prize: {
    unit?: number;
    noBoostUnit?: number;
    description: string;
}): string {
    if (!prize.unit) {
        return '';
    }
    let unitString = '';
    const noBoostUnit = prize.noBoostUnit || prize.unit;
    try {
        const unit = Math.round(prize.unit / noBoostUnit);
        if (unit > 1) {
            unitString = ` *${unit}`;
        }
    } catch (error) {
        console.info('error in prizeUnit', error);
    }
    return unitString;
}
